import { Skeleton } from "@/components/ui/skeleton";
import "@/components/launch/launch-theme.css";

/**
 * Launch page skeleton — matches the dark launch theme and hero layout.
 * Shown via <Suspense fallback> while the LaunchPage chunk loads.
 */
export function LaunchSkeleton() {
  return (
    <div className="launch-theme">
      <div className="min-h-screen bg-launch-gradient-soft text-launch-foreground">
        {/* Top nav */}
        <header className="mx-auto flex max-w-7xl items-center justify-between px-6 py-5">
          <Skeleton className="h-8 w-28 bg-launch-foreground/10" />
          <div className="hidden gap-6 md:flex">
            <Skeleton className="h-4 w-16 bg-launch-foreground/10" />
            <Skeleton className="h-4 w-20 bg-launch-foreground/10" />
            <Skeleton className="h-4 w-16 bg-launch-foreground/10" />
          </div>
          <Skeleton className="h-9 w-28 rounded-full bg-launch-foreground/10" />
        </header>

        {/* Hero */}
        <section className="mx-auto max-w-5xl px-6 pt-12 pb-24 text-center">
          <Skeleton className="mx-auto mb-6 h-6 w-48 rounded-full bg-launch-foreground/10" />
          <Skeleton className="mx-auto mb-4 h-14 w-full max-w-3xl bg-launch-foreground/10" />
          <Skeleton className="mx-auto mb-4 h-14 w-3/4 bg-launch-foreground/10" />
          <Skeleton className="mx-auto mb-10 h-5 w-2/3 bg-launch-foreground/10" />
          <div className="mx-auto flex max-w-xl flex-col gap-3 sm:flex-row">
            <Skeleton className="h-12 flex-1 rounded-full bg-launch-foreground/10" />
            <Skeleton className="h-12 w-full rounded-full bg-launch-foreground/10 sm:w-40" />
          </div>
        </section>

        {/* Feature grid */}
        <section className="mx-auto grid max-w-6xl gap-6 px-6 pb-24 sm:grid-cols-2 lg:grid-cols-3">
          {Array.from({ length: 6 }).map((_, i) => (
            <div key={i} className="rounded-2xl border border-launch-border p-6">
              <Skeleton className="mb-4 h-10 w-10 rounded-lg bg-launch-foreground/10" />
              <Skeleton className="mb-2 h-5 w-3/4 bg-launch-foreground/10" />
              <Skeleton className="h-4 w-full bg-launch-foreground/10" />
              <Skeleton className="mt-2 h-4 w-5/6 bg-launch-foreground/10" />
            </div>
          ))}
        </section>
      </div>
    </div>
  );
}
